document.documentElement.classList.add('js');
document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  const open = [...document.querySelectorAll('.site-header details[open]')];
  open.forEach(detail => { detail.open = false; });
  if (open.length) open[0].querySelector('summary').focus();
});
document.addEventListener('click', event => {
  document.querySelectorAll('.site-header details[open]').forEach(detail => {
    if (!detail.contains(event.target)) detail.open = false;
  });
});
